import { CpOrderSettlementType } from 'state/secondaryMarket/cpOrder/referential/client/client.model';

export const formatSettlementType = (settlementType: CpOrderSettlementType | undefined | null): string | undefined =>
  settlementType
    ? `${settlementType.settlementType} - ${settlementType.marketType} (${settlementType.description})`
    : undefined;
